import { App } from '@system/App'
import * as PIXI from 'pixi.js'
import { Label } from './Label'
import { LabelType } from './Label'
import { extractNumber } from '@utils/helpers'
import CustomEase from "gsap/CustomEase";
import gsap from 'gsap'
import { currentMultiplier, elapsedTime } from '@system/ClassicCrash'


export class Graph {
    graphics: PIXI.Graphics | null = null
    startX: number = App.config.graphStartPoint.startX(App.app);
    startY: number = App.config.graphStartPoint.startY(App.app);
    container: PIXI.Container = new PIXI.Container()

    canvasWidth: number = App.app.renderer.width
    canvasHeight: number = App.app.renderer.height

    xLabels: Label[] = [] //x array of labels
    yLabels: Label[] = [] //y array of labels

    maxXvalue: number = App.config.axis.maxXvalue  //max initial X axis value (Time)
    maxYvalue: number = App.config.axis.maxYvalue// max  initial Y axis value (Multiplier)
    minYvalue: number = App.config.axis.minYvalue// min y axis  value (Multiplier)

    xStep: number = App.config.axis.xStep
    yStep: number = App.config.axis.yStep

    xEachStep = (App.app.renderer.width - App.config.graphStartPoint.startX(App.app)) / App.config.axis.xStepsNumber//step on x axis for time
    yEachStep = (App.config.graphStartPoint.startY(App.app)) / App.config.axis.yStepsNumber //step on y axis for multiplier

    xLabelOffset: number = App.config.axis.xLabelOffset // between X Axis and its labels
    yLabelOffset: number = App.config.axis.yLabelOffset // between Y Axis and its labels

    xAnimationActive: boolean = false
    yAnimationActive: boolean = false

    private lastXLabelTime: number = Date.now(); // Track the last time a label was created
    private lastYLabelTime: number = Date.now(); // Track the last time a label was created
    private xLabelInterval: number = App.config.axis.xlabelInterval; //time to create label on X
    private yLabelInterval: number = App.config.axis.yLabelInterval; //time to create label on Y

    private xTimer: number = Date.now() //start X time tracker
    private yTimer: number = Date.now() //start Y time tracker

    private yLastPosition = 0
    private xLastPosition = 0



    //   "M0,0 C0.126,0.382 0.155,0.621 0.351,0.685 0.615,0.77 0.772,0.754 1,0.8 "
    // M0,0 C0.126,0.382 0.323,0.621 0.52,0.685 0.783,0.77 0.772,0.754 1,0.8 

    constructor() {

        gsap.registerPlugin(CustomEase)
        CustomEase.create(
            "slowPower1Out",
            "M0,0 C0.126,0.382 0.323,0.621 0.52,0.685 0.783,0.77 0.772,0.754 1,0.8 "
        )
        //draw Axises
        this.graphics = new PIXI.Graphics()
        this.drawGraph()
        this.container.addChild(this.graphics)
        //create labels
        this.createLabels()
    }





    drawGraph(newWidth?: number) {
        if (!this.graphics) return
        this.graphics.clear()
        //xAxis
        this.graphics.moveTo(this.startX, this.startY)
        this.graphics.lineTo(newWidth || this.canvasWidth, this.startY)
        this.graphics.stroke({ width: 1, color: 0x808080 })
        //yAxis
        this.graphics.moveTo(this.startX, this.startY)
        this.graphics.lineTo(this.startX, 0)
        this.graphics.stroke({ width: 1, color: 0x808080 })
    }

    resize(newWidth: number, newHeight: number) {
        if (!this.graphics) return
        this.startY = App.config.graphStartPoint.startY(App.app)
        this.startX = App.config.graphStartPoint.startX(App.app)

        this.drawGraph(newWidth)
        // this.resizeLabels(newWidth, newHeight)

    }

    resizeLabels(newWidth: number, newHeight: number) {
        //change the steps values on resize
        this.xEachStep = (newWidth - App.config.graphStartPoint.startX(App.app)) / App.config.axis.xStepsNumber
        this.yEachStep = (App.config.graphStartPoint.startY(App.app)) / App.config.axis.yStepsNumber
        //Calculate dynamic font size
        const baseFontSize = 60; // Base font size for reference
        const fontSizeFactor = 0.7; // Factor to scale font size (adjust as needed)
        const newFontSize = Math.max(baseFontSize * (newWidth / 1920) * fontSizeFactor, 7);
        //Recalculate label positions based on the new width and height
        this.xLabels.forEach((label, index) => {
            label.text!.style.fontSize = newFontSize
            // const newX = this.startX + (relativeX * (newWidth / this.canvasWidth) * this.xEachStep);
            const newX = this.startX + index * this.xEachStep * 2
            label.continer.position.x = newX;
            label.continer.position.y = this.startY + this.xLabelOffset;
            label.startY = this.startY
            label.positionXLabe()
            label.resizeXDash()

        });

        this.yLabels.forEach((label, index) => {
            label.text!.style.fontSize = newFontSize

            const newY = this.startY - index * this.yEachStep - this.yEachStep
            label.continer.position.y = newY;
            label.continer.position.x = this.yLabelOffset;
            label.positionYLabe()
            label.startX = this.startX
            // Redraw the dash
            label.resizeYDash()

        });
        // Store the current width and height for future resize calculations
        this.canvasWidth = newWidth;
        this.canvasHeight = newHeight;
    }

    createLabel(x: number, y: number, graph: PIXI.Container, type: LabelType, content: string, startX: number, startY: number) {
        return new Label(x, y, graph, type, content, startX, startY, this.xLabels.length, this.yLabels.length)
    }

    createLabels() {
        //x labels
        // let xValue = 0
        for (let i = 0; i <= this.maxXvalue; i += this.xStep) {

            const xPos = (this.startX + i * this.xEachStep)
            const label = this.createLabel(xPos, this.startY + this.xLabelOffset, this.container, 'horizontal', `${i}`, this.startX, this.startY)
            // xValue += this.xStep
            this.container.addChild(label.continer)
            this.xLabels.push(label)
        }
        // y labels

        let yLabelPosition = 1
        for (let i = this.minYvalue; i <= this.maxYvalue; i += this.yStep) {
            const formattedValue = Number(i.toFixed(1))
            const yPos = (this.startY - yLabelPosition * this.yEachStep)
            yLabelPosition++
            const label = this.createLabel(this.yLabelOffset, yPos, this.container, 'vertical', `${formattedValue}x`, this.startX, this.startY)
            this.container.addChild(label.continer)
            this.yLabels.push(label)
        }
        // console.log("X LABELS", this.xLabels)
        // console.log("Y LABELS", this.yLabels)
        this.yLastPosition = this.yLabels[this.yLabels.length - 1].continer.y
        this.xLastPosition = this.xLabels[this.xLabels.length - 1].continer.x

    }



    updateXlabels() {

        //to control animation
        if (!this.xAnimationActive) {
            this.xAnimationActive = true
            this.lastXLabelTime = Date.now()
            this.xTimer = Date.now()
            // console.log("# current multiplier", currentMultiplier)
            if (elapsedTime / 1000 > 20) {
                // Collect labels to be removed
                const labelsToRemove: Label[] = [];
                this.xLabels.forEach((e) => {
                    const value = parseFloat(e.text?.text || "0");
                    // Add labels that are not multiples of 20 or less than 20 but not 0
                    if (value % 20 !== 0) {
                        labelsToRemove.push(e);
                    }
                });
                // Remove collected labels
                labelsToRemove.forEach((e) => {
                    e.remove();
                    this.xLabels = this.xLabels.filter(label => label !== e);
                });

            }
        }

        const currentTime = Date.now();
        //track the time of all label animation
        const xTimeTracker = currentTime - this.xTimer
        //track the time done after last label creation
        const elapsedTimeInternal = currentTime - this.lastXLabelTime;

        this.xLabels.forEach((e, index) => {
            if (e.content === '0') return //exclude zero
            // e.continer.x -= 1
            e.startAnimation(index)
            //remove when esceeds the borders
            if (e.continer.position.x <= this.startX + 20) {
                //unstage it 
                e.remove()
                // Remove label from the array
                this.xLabels.splice(index, 1);
            }

        })

        if (elapsedTimeInternal >= this.xLabelInterval) {
            this.addXLabel();
            this.lastXLabelTime = currentTime; // Update the last label creation time
        }
    }

    updateYlabels() {

        //to control animation
        if (!this.yAnimationActive) {
            this.yAnimationActive = true
            this.lastYLabelTime = Date.now()
            if(currentMultiplier >=3){
                const labelsToRemove: Label[] = [];
                this.yLabels.forEach((e) => {
                    const value = extractNumber(e.text!.text);
                    // Add labels that are not multiples of 20 or less than 20 but not 0
                    if (!Number.isInteger(value)) {
                        labelsToRemove.push(e);
                    }
                });
                // Remove collected labels
                labelsToRemove.forEach((e) => {
                    e.remove();
                    this.yLabels = this.yLabels.filter(label => label !== e);
                });
            }
        }

        const currentTime = Date.now();
        const elapsedTime = currentTime - this.lastYLabelTime;
        this.yLabels.forEach((e, index) => {
            if (!e) return
            // e.continer.y += 1
            e.startAnimation(index)
            //remove when esceeds the borders
            if (e.continer.position.y >= this.startY - 20) {
                //unstage it 
                e.remove()
                // Remove label from the array
                this.yLabels.splice(index, 1);
            }


        })
        if (elapsedTime >= this.yLabelInterval) {
            this.addYLabel();
            this.lastYLabelTime = currentTime; // Update the last label creation time
        }
    }

    addXLabel() {
        // Create a new X label based on the last value
        this.maxXvalue += this.xStep; //put this instead of elapsed time if didn't work
        if (elapsedTime / 1000 >= 20) {
            this.xLabelInterval = 20000;
            this.xStep = 20;

            // Collect labels to be removed
            const labelsToRemove: Label[] = [];
            this.xLabels.forEach((e) => {
                const value = parseFloat(e.text?.text || "0");
              
                // Add labels that are less 20 and not 0 
                if (value < 20 && value !==0) {
                    labelsToRemove.push(e);
                }
            });
            // Remove collected labels
            labelsToRemove.forEach((e) => {
                e.remove();
                this.xLabels = this.xLabels.filter(label => label !== e);
            });
        } else {
            this.xLabelInterval = 2000;
        }
        const xPos = this.xLastPosition + this.xEachStep;
        const newXLabel = this.createLabel(xPos, this.startY + this.xLabelOffset, this.container, 'horizontal', `${(elapsedTime / 1000 - 1).toFixed(0)}`, this.startX, this.startY);
        this.xLabels.push(newXLabel);
        this.container.addChild(newXLabel.continer);
    }

    addYLabel() {
        // Create a new Y label based on the last value
        this.maxYvalue += this.yStep;

        if (currentMultiplier >= 6) {
            this.yStep = 1
            this.yLabelInterval = 3000
        }
        else if (currentMultiplier >= 3) {
            this.yStep = 1
            this.yLabelInterval = 4000

        }

        if (currentMultiplier >= 3) {
            // Collect labels to be removed
            const labelsToRemove: Label[] = [];
            this.yLabels.forEach((e) => {
                const value = extractNumber(e.text!.text);
                // Add labels that are not multiples of 20 or less than 20 but not 0
                if (!Number.isInteger(value)) {
                    labelsToRemove.push(e);
                }
            });
            // Remove collected labels
            labelsToRemove.forEach((e) => {
                e.remove();
                this.yLabels = this.yLabels.filter(label => label !== e);
            });
        }

        if (this.yLabels.length === 4 && currentMultiplier > 3) {
            this.yLabels[0].remove()
            this.yLabels.splice(0, 1)
        }
        const yPos = this.yLastPosition - this.yEachStep;
        const value = currentMultiplier >= 3 ? `${currentMultiplier.toFixed(0)}.0` : this.maxYvalue.toFixed(1);
        const newYLabel = this.createLabel(this.yLabelOffset, yPos, this.container, 'vertical', `${value}x`, this.startX, this.startY);
        this.yLabels.push(newYLabel);
        this.container.addChild(newYLabel.continer);
        if (this.yLabelInterval === 250) {
            this.yLabelInterval = 1500
        }
    }


    resetValues() {

        this.maxXvalue = App.config.axis.maxXvalue
        this.maxYvalue = App.config.axis.maxYvalue

        this.xStep = App.config.axis.xStep
        this.yStep = App.config.axis.yStep

        this.xAnimationActive = false
        this.yAnimationActive = false

        this.xLabelInterval = App.config.axis.xlabelInterval;
        this.yLabelInterval = App.config.axis.yLabelInterval;
    }

    resetLabels() {
        // Remove all existing labels
        this.xLabels.forEach(label => { label.remove() });
        this.yLabels.forEach(label => { label.remove() });

        //reset  values
        this.resetValues()
        // Clear label arrays
        this.xLabels = [];
        this.yLabels = [];

        // Create new labels
        this.createLabels();
    }


    deleteLabels() {
        // Remove all existing labels
        this.xLabels.forEach(label => { label.remove() });
        this.yLabels.forEach(label => { label.remove() });

        //reset  values
        this.resetValues()
        // Clear label arrays
        this.xLabels = [];
        this.yLabels = [];
    }


    reset() {
        this.resetValues()

        this.resetLabels()
    }


    // pauseCurve() {
    //     this.curve?.pauseAnimation()
    // }
    pauseLabels() {
        this.xLabels.forEach(label => { label.pauseAnimation() });
        this.yLabels.forEach(label => { label.pauseAnimation() });
    }

    destroy() {

        this.deleteLabels()
        this.container.removeChild(this.graphics!)
        this.container.destroy()
    }
}